import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { mtCurrencyDto, profileDto } from '../../../api/Dtos/profileDto';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { getService, postService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useToaster } from '../../../Toaster/Toaster';
import { mtCountryDto } from '../../../api/interfaces/addUser';
import { useLoader } from '../../../Loader/LoaderContext';
import dynamicTextPopup from '../Modals/dynamicTextPopup';
import DynamicTextPopup from '../Modals/dynamicTextPopup';

function EditHospitalProfile() {
  const [formData, setFormData] = useState<profileDto>();
  const [showConfirmation, setShowConfirmation] = useState(false);
   const [searchParams] = useSearchParams();
        const leadId = searchParams.get("leadId");
        const names = searchParams.get("name");
    const [events, setEvents] = useState<any[]>([]);
      const [events1, setEvents1] = useState<any[]>([]);
    const [data,setData]=useState<profileDto | null>(null);
        const navigate = useNavigate();
        const location = useLocation();
        const path = location.pathname;
        const users = () => {
          if(path ==='/portals/leads/viewUser/editHospitals/'){
            navigate("/portals/leads/viewUser")
          }else if( path === "/portals/vendors/activeVendor/editHospitals"){
            navigate('/portals/vendors/activeVendor')
          }else if(path === "/portals/vendors/inActiveVendor/editHospitals"){
            navigate('/portals/vendors/inActiveVendor')
          }else if( path === "/portals/bookings/viewBooking/editHospitals" && names =='booked'){
            navigate('/portals/bookings/viewBooking')
          }else if( path === "/portals/bookings/viewBooking/editHospitals" && names =='confirmed'){
            navigate('/portals/bookings/confirmedBooking')
          }
          else if( path === "/portals/bookings/confirmedBooking/editHospitals" && names =='confirmed'){
            navigate('/portals/bookings/confirmedBooking')
          }
          else{
            navigate('/portals/proposals/viewProposal')
          }
            // if (path === "/portals/leads/viewUser/previewHospital") {
                ; // Navigate to viewUser for Leads
            // }
        };
        const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
    const [files, setFiles] = useState<(File | null)[]>([]);
    const services = [
        { id: 1, name: 'IVF Treatment' },
        { id: 2, name: 'IUI Treatment' },
        { id: 3, name: 'Surrogacy' },
        { id: 4, name: 'Egg/Sperm Freezing Treatment' },
        { id: 5, name: 'Fertility Preservation' },
        { id: 6, name: 'Fertility Testing' },
      ];
      const treatmentMapping = {
        'IVF Treatment': 'IVF_TREATMENT',
        'IUI Treatment': 'IUI_TREATMENT',
        'Surrogacy': 'SURROGACY',
        'Egg/Sperm Freezing Treatment': 'SPERM_OR_EGG_FREEZING',
        'Fertility Preservation': 'FERTILITY_PRESERVATION',
        'Fertility Testing': 'FERTILITY_TESTING',
      } as const; // This ensures that the keys are treated as string literals
      
      // Function to map the treatment name to the backend value
      const formatTreatmentType = (serviceName: string): string | null => {
        return treatmentMapping[serviceName as keyof typeof treatmentMapping] || null;
      };
      const [expanded, setExpanded] = useState<string | false>(false);
      const [expanded1, setExpanded1] = useState<string | false>(false);
     const [defaultCurrencyId, setDefaultCurrencyId] = useState<number | null>(null);
    const [mtCurrencyData, setMtCurrency] = useState<mtCurrencyDto[]>([]);
    const { showToast } = useToaster();
  const [isLoading, setIsLoading] = useState(true);
  const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
  const [phoneCode, setPhonecode] = useState({ isoCode: "", code: "" });
  const [selectedCountry, setSelectedCountry] = useState("");
  const [submittedData, setSubmittedData] = useState<profileDto | null>(null);
   const [selectedFile, setSelectedFile] = useState<File | null>(null);
      const [file, setFile] = useState<string | null>(null);
      
      const {
        register,
        handleSubmit,
        control,
        watch,
        setValue,
        reset,
        formState: { errors },
      } = useForm<profileDto>({
        defaultValues: {
          name: '',
          email: '',
          phoneNo: '',
          phoneisoCode: '',
          hospitalInfo: '',
          specialization: '',
          size: '',
          street: '',
          apartment: '',
          state: '',
          postalCode: '',
          mtCountryDto: { id: 0, name: '' },
          city: '',
          imageDto: {},
          serviceOfferedDtos: [{ type: '', cost: '', mtCurrencyDto: { id: 0, name: '' } }],
          leaderShipTeamDtos: [{ id: 0, name: '', gender: '', designation: '', bio: '', address: '', fileDto: {} }],
          hospitalCenterReqDtos: [{ id: 0, branchAddress: '', specialization: '', centerSize: '', imageDto: {}, type: '', name: '' }],
          profileStatus: '',
        },
        mode: 'onChange',
      });
    const watchedServices = watch('serviceOfferedDtos');
      const { setLoading } = useLoader();
      useEffect(() => {
        const initializeData = async () => {
          setLoading(true);
          try {
            await mtCountryDtoData();
            await fetchMtCurrencyData();
            await fetchDetails();
          } catch (error) {
            console.error("Error during initialization:", error);
          } finally {
            setLoading(false);
          }
        };
      
        initializeData();
      }, []);
     const fetchMtCurrencyData = async () => {
         try {
           const response = await getService(API_ENDPOINTS.mtCurrency);
           setMtCurrency(response.data);
           const inrCurrency = response.data.find(
             (currency: mtCurrencyDto) => currency.name === 'INR'
           );
           if (inrCurrency) {
             setDefaultCurrencyId(inrCurrency.id);
             services.forEach((_, index) => {
               setValue(`serviceOfferedDtos.${index}.mtCurrencyDto.id`, inrCurrency.id);
             });
           }
         } catch (error) {
           console.error('Error fetching currency data:', error);
         }
       }
       const handleAddEvent = () => {
        const newEventId = events.length + 1;
        setEvents([
          ...events,
          {
            id : newEventId,
            name: `Event ${newEventId}`,
            gender: "",
            designation: "",
            bio: "",
            address: "",
            
            fileDto: {
              name: "",
              base64Str: "",
              type: "",
              documentUrl: "",
            },
          },
        ]);
        setExpanded(`panel${newEventId}`);
      };
      const handleAddEvents = () => {
        const newEventId = events1.length + 1;
        setEvents1([
          ...events1,
          {
            id: newEventId,
            name: `Event ${newEventId}`,
            startDate: "",
            endDate: "",
            contactPersonName: "",
            contactPersonEmail: "",
            phoneNo: "",
            mtCountryDto: {
              id: null,
              name: "",
              code: "",
              isoCode: "",
            }, // Default mtCountryDto object
            venue: "",
            link: "",
            type: "",
            imageDto: {
              name: "",
              base64Str: "",
              type: "",
              documentUrl: "",
            },
          },
        ]);
        setExpanded1(`panel${newEventId}`);
      };
       const fetchDetails = async () => {
            try {
              let url:string;
              const response = await getService(API_ENDPOINTS.getProfile+"?leadId="+leadId); // Fetch post details using 'id'
        setSubmittedData(response.data);
        
        const res =response.data;
      
        setEvents(response.data.leaderShipTeamDtos);
        setEvents1(response.data.hospitalCenterReqDtos)
        const countryData = await mtCountryDtoData();
       
        const selectedIsoCode = response.data?.mtCountryDto?.id;
         const selectedCountry = countryData.find(
            (country: any) => country.id === selectedIsoCode
          );
          if (selectedCountry) {
            setPhonecode({
              isoCode: selectedCountry.isoCode,
              code: selectedCountry.code,
            });
            setValue("phoneisoCode", selectedIsoCode);}else{
              const selectedCountry = countryData.find(
                (country: any) => country.id == "1"
              );
              setPhonecode({
                isoCode: selectedCountry.isoCode,
                code: selectedCountry.code,
              });
              setValue("phoneisoCode", selectedIsoCode);
             }
        reset({
          ...response.data, // Resetting other data from the response
        });
        setSelectedCountry(response.data?.mtCountryDto?.id);
              setTimeout(() => {
                setLoading(false); // Stop loader after 500ms
                setIsLoading(false); // Stop local loading
              }, 500);
            } catch (error) {
              console.error("Error fetching post details:", error);
              setTimeout(() => {
                setLoading(false); // Stop loader in case of error
                setIsLoading(false);
              }, 500);
            }
          };
         
      const mtCountryDtoData = async () => {
          setLoading(true);
          try {
            const response = await getService(API_ENDPOINTS.countryData);
            setMtCountry(response.data);
            return response.data;
          } catch (error) {
            console.error("Error fetching vehicle data:", error);
          } finally {
            setTimeout(() => {
              setLoading(false);
            }, 500);
          }
        };
        const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
    const handleChanges =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded1(isExpanded ? panel : false);
    };
        const phoneNuberChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
          const selectedIsoCode = e.target.value;
          console.log("Selected ISO Code:", selectedIsoCode);
        
          const selectedCountry = mtContryData.find(
            (country: any) => country.isoCode === selectedIsoCode
          );
        
          if (selectedCountry) {
            setPhonecode({
              isoCode: selectedCountry.isoCode,
              code: selectedCountry.code,
            });
        
            console.log("Updated Phone Code:", {
              isoCode: selectedCountry.isoCode,
              code: selectedCountry.code,
            });
        
            setValue("phoneisoCode", selectedIsoCode); // Update the selected value for the form
          }
        };
        const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
            const selectedCountryId = e.target.value;
            setSelectedCountry(selectedCountryId);
        
            const selectedCountry = mtContryData.find(
              (country: any) => country.id == selectedCountryId
            );
            if (selectedCountry) {
              setPhonecode((prev) => {
                const updatedPhoneCode = {
                  isoCode: selectedCountry.isoCode,
                  code: selectedCountry.code,
                };
                return updatedPhoneCode;
              });
              console.log(phoneCode);
            }
          };
          const handleFileChanges = (
            event: React.ChangeEvent<HTMLInputElement>,
            index: number
          ) => {
            const file = event.target.files?.[0];
            const allowedTypes = ["image/png", "image/jpeg"];
            const maxSizeInMB = 3;
        
            if (file) {
              // Validate file type
              if (!allowedTypes.includes(file.type)) {
                alert("Please select a valid image (PNG or JPG).");
                return;
              }
        
              // Validate file size
              if (file.size > maxSizeInMB * 1024 * 1024) {
                alert(`File size should not exceed ${maxSizeInMB} MB.`);
                return;
              }
        
              // Create a file URL
              const fileUrl = URL.createObjectURL(file);
        
              // Update the file array
              setFiles((prevFiles) => {
                const updatedFiles = [...prevFiles];
                updatedFiles[index] = file; // Assign the file at the given index
                return updatedFiles;
              });
        
              // Update the preview URL array
              setSelectedFiles((prevUrls) => {
                const updatedUrls = [...prevUrls];
                updatedUrls[index] = fileUrl; // Assign the URL at the given index
                return updatedUrls;
              });
            }
          };
          const convertFileToBase64 = (file: File): Promise<string> => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => resolve(reader.result as string);
              reader.onerror = (error) => reject(error);
            });
          };
            const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
              if (e.target.files && e.target.files[0]) {
                const selectedFile = e.target.files[0];
                setSelectedFile(selectedFile);
                // setValue('imageDto',selectedFile)
                // Convert the file to a Base64 string
                const preview = await convertToBase64(selectedFile);
                setFile(preview);
              }
            };
            const convertToBase64 = (file: File): Promise<string> => {
              return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result as string);
                reader.onerror = (error) => reject(error);
              });
            };
        const onFormSubmit:SubmitHandler<profileDto> = async (data) => {
          setFormData(data);
          setShowConfirmation(true)
              
          }
          const handleClosePopup = () => setShowConfirmation(false);
          const saveData =async ()=>{
            setShowConfirmation(true);
            console.log(data);
            setLoading(true);
            try {
              const filteredServices = watchedServices
.filter((service) => service.type && service.cost && service.mtCurrencyDto.id) // Only valid services
.map((service, index) => ({
  ...service,
  type: formatTreatmentType(services[index].name), // Map the service name
  mtCurrencyDto: {
    id: parseInt(service.mtCurrencyDto.id as unknown as string, 10), // Ensure that the id is parsed as a number
  },
}));
const updatedLeaderShipTeamDtos = await Promise.all(
  (formData?.leaderShipTeamDtos ?? []).map(async (team, index) => {
    if (files[index]) {
      const base64Str = await convertFileToBase64(files[index] as File);
      const name = (files[index] as File).name;
      const type = (files[index] as File).type;

      return {
        ...team,
        fileDto: {
          base64Str: base64Str,
          name,
          type,
        },
      };
    }
    return team; // Return unchanged object if no file is uploaded
  })
);
                let payload={
                  // ...submittedData,
                  leadId:leadId,
                  name:formData?.name,
                  email:formData?.email,
                  phoneNo:formData?.phoneNo,
                  hospitalInfo:formData?.hospitalInfo,
                  specialization:formData?.specialization,
                  size:formData?.size,
                  imageDto:{
                    name: selectedFile?.name,
                    type: selectedFile?.type,
                    base64Str: file,
                  },
                  street:formData?.street,
                  apartment:formData?.apartment,
                  state:formData?.state,
                  postalCode:formData?.postalCode,
                   mtCountryDto: formData?.mtCountryDto ? {
                                id: parseInt(formData?.mtCountryDto as unknown as string, 10),
                              } : null,
                              city:formData?.city,
                              serviceOfferedDtos: filteredServices,  
                              leaderShipTeamDtos: updatedLeaderShipTeamDtos,
                              hospitalCenterReqDtos: formData?.hospitalCenterReqDtos.map((center, index) => ({
                                  ...center,
                                  id: submittedData?.hospitalCenterReqDtos[index]?.id || null, // Ensure the `id` field is included
                                })),    
                              
                }
                  const response = await postService(API_ENDPOINTS.saveProfile,payload);
                  if(response){
                    setSelectedCountry("");
                    // onSave();
                    handleClosePopup();
                    if(path ==='/portals/leads/viewUser/editHospitals'){
                      navigate('/portals/leads/viewUser/previewHospital?leadId='+leadId)
                    }else if(path === "/portals/vendors/inActiveVendor/editHospitals"){
                      navigate('/portals/vendors/inActiveVendor/previewHospital?leadId='+leadId)
                    }else if( path === "/portals/bookings/viewBooking/editHospitals" && names =='booked'){
                      navigate('/portals/bookings/viewBooking/previewHospital?leadId='+leadId+"&name=booked")
                    }else if( path === "/portals/bookings/viewBooking/editHospitals" && names =='confirmed'){
                      navigate('/portals/bookings/viewBooking/previewHospital?leadId='+leadId+"&name=confirmed")
                    }else if( path === "/portals/bookings/confirmedBooking/editHospitals"){
                      navigate('/portals/bookings/confirmedBooking/previewHospital?leadId='+leadId+"&name=confirmed")
                    }

                    else{
                      navigate('/portals/proposals/viewProposal/previewHospital?leadId='+leadId)
                    }
                    showToast('Profile has been updated successfully.','success','')
                  }
            } catch (error: any) {
                // setApiError(error.response?.data?.message);
                console.error('Login error:', error);
                if(error.response?.data?.message === 'Invalid Otp. Please try again.'){
                  
                }
            }
            finally {
                setLoading(false);
            }
            
          }
          const viewLeadUser =()=>{
            if(path ==='/portals/leads/viewUser/editHospitals'){
              navigate('/portals/leads/viewUser/previewHospital?leadId='+leadId)
            }else if( path === "/portals/vendors/activeVendor/editHospitals"){
              navigate('/portals/vendors/activeVendor/previewHospital?leadId='+leadId)
            }else if(path === "/portals/vendors/inActiveVendor/editHospitals"){
              navigate('/portals/vendors/inActiveVendor/previewHospital?leadId='+leadId)
            }else if( path === "/portals/bookings/viewBooking/editHospitals" && names =='booked'){
              navigate('/portals/bookings/viewBooking/previewHospital?leadId='+leadId+"&name=booked")
            }else if( path === "/portals/bookings/viewBooking/editHospitals" && names =='confirmed'){
              navigate('/portals/bookings/viewBooking/previewHospital?leadId='+leadId+"&name=confirmed")
            }else if(path === "/portals/bookings/confirmedBooking/editHospitals" && names =='confirmed'){
              navigate('/portals/bookings/confirmedBooking/previewHospital?leadId='+leadId+"&name=confirmed")
            }
            else{
              navigate('/portals/proposals/viewProposal/previewHospital?leadId='+leadId)
            }
            
          }
  return (
    
    <div className="h-full py-2 w-full">
    <div className="flex items-center cursor-pointer mb-4">
        <h2
            className="mr-2 text-gray-700 font-semibold text-sm"
            onClick={users}
        >
           {path === "/portals/proposals/viewProposal/editHospitals" ? 'Proposal' :  path === "/portals/vendors/activeVendor/editHospitals" || path === "/portals/vendors/inActiveVendor/editHospitals" ? 'Vendors':
            path === "/portals/bookings/viewBooking/editHospitals" || path ==='/portals/bookings/confirmedBooking/editHospitals'  ? 'Booked' :
           'Leads'} 
            
        </h2>{" "}

        <img src="/images/arrowIcons.svg" className="mr-2" />{" "}
        <span className="text-gray-400 font-semibold text-sm">
        {path === "/portals/proposals/viewProposal/editHospitals" ? 'View Proposals' : path === "/portals/vendors/activeVendor/editHospitals" || path === "/portals/vendors/inActiveVendor/editHospitals" ? 'View Vendors' :
        path === "/portals/bookings/viewBooking/editHospitals" && names =='booked' ? 'View Booked' :
        (path === "/portals/bookings/viewBooking/editHospitals" || path === "/portals/bookings/confirmedBooking/editHospitals") && names == 'confirmed' ? 'Confirmed Booked' :
        'View Leads'}
        </span>
    </div>
    <div className='flex justify-between w-full'>
                <div className='flex items-center mb-2'>
                    <img src='/images/back.svg' className='mr-2 cursor-pointer' onClick={viewLeadUser} />
                    <h1 className="text-2xl font-bold text-[#2D2E2F] mr-3">
                    {path === "/portals/proposals/viewProposal/editHospitals" ?  'Edit Proposal Details' :  path === "/portals/vendors/activeVendor/editHospitals" || path === "/portals/vendors/inActiveVendor/editHospitals" ? 'Edit Vendors Details' :
                    path === "/portals/bookings/viewBooking/editHospitals" ? 'Edit Booked Details' :
                    path === "/portals/bookings/confirmedBooking/editHospitals" ? 'Edit Confirm Booking Details' : 
                    'Edit Lead Details'} 
                      </h1>
                </div>
               
            </div>
            <div className='mt-2 scroolCls h-[80vh] overflow-y-scroll '>
         <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className='  rounded-lg'>
       <div className=''>
       <div className='p-8 bg-white'>
       <p className='font-bold text-2xl text-primary-color border-b pb-4 border-b-gray-200'>Add basic information</p>
      <div className='w-[80%] '>
      <div className='flex items-center py-3 mt-4'>
       <img src={
                          file
                            ? (file as string)
                            : selectedFile
                            ? URL.createObjectURL(selectedFile)
                            : submittedData?.imageDto?.documentUrl || '/images/userImg.svg'
                        }
                        alt="Preview" className='w-[80px] h-[80px] mr-3 rounded-full'  />
       <div>
              <p className="font-semibold text-gray-900 text-base font-sans mb-0">
              Upload Hospital Photo
              </p>
              <p className="text-sm font-normal text-gray-500 mt-1 font-sans mb-3">
                Photo should be atleast in 150px X 150px
              </p>
              <label className=' mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer'>
            Upload new photo
            <input
              type="file" 
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />
          </label>
            </div>
       </div>
       <div className="grid grid-cols-1 gap-4 mt-2">
      
      <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-gray-700 font-semibold text-sm font-sans"
                >
                Hospital Name
                </label>
                <div className="input-group mb-3 mt-2">
                   <input
                    {...register("name", {
                      required: 'Name is required',
                    })}
                    type="text"
                    placeholder="Enter Hospital Name"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
                  )}
                </div>
              </div>
      </div>
       <div className="grid grid-cols-2 gap-7 mb-2 mt-2">
      
      <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-gray-700 font-semibold text-sm font-sans"
                >
                  Email
                </label>
                <div className="input-group mb-3 mt-2">
                   <input
                    {...register("email", {
                      required: 'Email is required',
                    })}
                    type="email"
                    disabled
                    placeholder="Enter your Email"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
                  )}
                </div>
              </div>
              <div className="form-group mb-3 mt-2">
                <label
                  htmlFor="username"
                  className="block text-gray-700 font-semibold text-sm font-sans"
                >
                  Phone Number
                </label>
                <div className=" form-group mb-4 sm:mb-0">
                  <div className="flex border border-gray-300 rounded mt-1 form-controls">
                    <select
                      value={phoneCode.isoCode || ""}
                      {...register("phoneisoCode")}
                      onChange={(e) => phoneNuberChange(e)}
                      className="border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none"
                    >
                      {mtContryData.map((item: any) => (
                        <option key={item.id} value={item.isoCode || ""}>
                          {item.isoCode}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      placeholder="Enter your phone number"
                      {...register("phoneNo")}
                      onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, "");
                      }}
                      className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                    />
                  </div>

                </div>
              </div>
              
      </div>
      <div className="grid grid-cols-1 gap-4 mt-2">
      
      <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm font-sans"
                >
                Hospital Info
                </label>
                <div className="input-group mb-3 mt-2">
                <textarea
                 rows={4}
                    placeholder="Enter Hospital Info"
                    {...register("hospitalInfo",{
                      maxLength: {
                        value: 1500,
                        message: "Hospital information cannot exceed 1500 characters. Please shorten your text.",
                      },
                     
                    })}
                    
                    className="w-full border font-normal font-Inter text-sm text-[#6B7280] p-2 rounded-md"
                  />
                  {errors.hospitalInfo && (
                    <p className="text-red-500 text-sm mt-1">{errors.hospitalInfo.message}</p>
                  )}
                </div>
              </div>
              
              
      </div>
      <div className="grid grid-cols-2 gap-5 mb-8">
      
      <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm font-sans"
                >
                  Specialization
                </label>
                <div className="input-group mb-3 mt-2">
                   <input
                    {...register("specialization", {
                      // required: 'specialization is required',
                    })}
                    type="text"
                    placeholder="Enter Specialization"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                  {errors.specialization && (
                    <p className="text-red-500 text-sm mt-1">{errors.specialization.message}</p>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm font-sans"
                >
                  Hospital Size
                </label>
                <div className=" mb-3 mt-2">
                <select
                                      
                                      {...register(
                                        `size`,
                                        {
                                       
                                        }
                                      )}
                                      className={`form-control p-2 rounded mt-1 w-full`}
                                    >
                                      <option value="">
                                        Select Center size
                                      </option>
                                      <option value="SMALL">Small</option>
                                      <option value="MEDIUM">Medium</option>
                                      <option value="LARGE">Large</option>
                                    </select>
                </div>
            
              </div>
      </div>
      <p className="border-b-2 border-gray-200"></p>
      <div className='mt-8'>
        <h2 className='text-gray-900 font-bold text-[20px]'>Address</h2>
        <div className="grid grid-cols-1 gap-4 mt-2">
      
      <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm font-Inter"
                >
                Street Address 
                </label>
                <div className="input-group mb-3 mt-2">
                   <input
                    {...register("street", {
                      // required: ' Street Address  is required',
                    })}
                    type="text"
                    placeholder="eg. Street 7"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                  {errors.street && (
                    <p className="text-red-500 text-sm mt-1">{errors.street.message}</p>
                  )}
                </div>
              </div>
              
              
      </div>
      <div className="grid grid-cols-1 gap-4 mt-2">
      
      <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm"
                >
                Location
                </label>
                <div className="input-group mb-3 mt-2">
                   <input
                    {...register("apartment", {
                      // required: 'Apartment is required',
                    })}
                    type="text"
                    placeholder="Enter Location"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                  {errors.apartment && (
                    <p className="text-red-500 text-sm mt-1">{errors.apartment.message}</p>
                  )}
                </div>
              </div>
              
              
      </div>
      <div className="grid grid-cols-2 gap-5 mt-2">
      
      <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm"
                >
                  Country
                </label>
                <div className="input-group mb-3 mt-2">
                <select
                    value={selectedCountry || ""}
                    {...register("mtCountryDto")}
                    onChange={(e) => handleCountryChange(e)}
                    className={`border p-2 rounded-md mt-1 w-full`}
                  >
                    <option value="">Select country</option>
                    {mtContryData.map((item: any) => (
                      <option
                        key={item.id}
                        value={item.id !== null ? item.id : ""}
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {/* {errors.firstName && (
                    <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
                  )} */}
                </div>
              </div>
              <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm"
                >
                  State
                </label>
                <div className="input-group mb-3 mt-2">
                <input
                    {...register("state", {
                      // required: 'Apartment is required',
                    })}
                    type="text"
                    placeholder="Enter state"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                  {/* {errors.lastName && (
                    <p className="text-red-500 text-sm mt-1">{errors.lastName.message}</p>
                  )} */}
                </div>
              </div>
              
      </div>
      <div className="grid grid-cols-2 gap-5 mt-2">
      
      <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm"
                >
                  City
                </label>
                <div className="input-group mb-3 mt-2">
                   <input
                    {...register("city", {
                     
                    })}
                    type="text"
                    placeholder="Enter City Name"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                  {errors.city && (
                    <p className="text-red-500 text-sm mt-1">{errors.city.message}</p>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label
                  htmlFor="username"
                  className="block text-[#374151] font-semibold text-sm"
                >
                  Postal Code
                </label>
                <div className="input-group mb-3 mt-2">
                   <input
                    {...register("postalCode", {
                      
                    })}
                    type="text"
                    placeholder="Enter Postal Code"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                  {errors.postalCode && (
                    <p className="text-red-500 text-sm mt-1">{errors.postalCode.message}</p>
                  )}
                </div>
              </div>
                 {/* Fixed Navigation Buttons */}
                
      </div>
     

{/* </form>  */}
      </div>
      </div>
       </div>
      <div className='bg-white p-8 mt-8'>
      <p className="font-bold text-2xl text-primary-color border-b pb-4 border-b-gray-200">Services Offered</p>
      <div className="grid grid-cols-2 gap-6">
       {services.map((service, index) => (
          <div
            key={service.id}
            className="border border-gray-200 rounded-lg p-6 flex flex-col items-start"
          >
            {/* Checkbox and Service Name */}
            <label className="flex items-center mb-5 font-bold text-base font-sans text-gray-900">
              <input
                type="checkbox"
                {...register(`serviceOfferedDtos.${index}.type`)}
                value={service.name}
                className="mr-4 w-[16px] h-[16px]"
              />
              {service.name}
            </label>
      
            {/* Cost and Currency Fields */}
            <p className="font-semibold font-Inter text-sm text-gray-700 pb-2">
              Approximate Cost
            </p>
            <div className="w-full flex space-x-2">
              {/* Currency Field */}
              <Controller
                control={control}
                name={`serviceOfferedDtos.${index}.mtCurrencyDto.id`}
                rules={{
                  required: watchedServices[index]?.type
                    ? 'Currency selection is required.'
                    : false, // Conditional validation
                }}
                render={({ field }) => (
                  <select
                    {...field}
                    value={field?.value ?? '' }
                    className="bg-white py-2 text-sm font-semibold text-gray-700 focus:outline-none"
                  >
                    <option value="">Select</option>
                    {mtCurrencyData.map((item) => (
                      <option key={item.id} value={item.id || ''}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors.serviceOfferedDtos?.[index]?.mtCurrencyDto?.id && (
                <p className="text-red-500 text-sm">
                  {errors?.serviceOfferedDtos[index]?.mtCurrencyDto?.id?.message}
                </p>
              )}
      
              {/* Cost Field */}
              <div>
                <input
                  type="number"
                  {...register(`serviceOfferedDtos.${index}.cost`, {
                    required: watchedServices[index]?.type
                      ? 'Cost is required.'
                      : false, // Conditional validation
                    valueAsNumber: true,
                  })}
                  placeholder="Enter Approximate Cost"
                  className="flex-grow border border-gray-300 rounded p-2 font-normal text-base"
                />
                {errors.serviceOfferedDtos?.[index]?.cost && (
                  <p className="text-red-500 text-sm">
                    {errors?.serviceOfferedDtos[index]?.cost?.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      </div>
     <div>
     <div className=" bg-white mt-8 p-8 rounded-lg">
      <p className="font-Inter font-bold text-2xl text-primary-color border-b pb-4 border-b-gray-200">
         Leadership Team 
        
      </p>
      <div className="form-group mb-5 mt-5 w-[80%]">
        {events.map((event: any, index: number) => (
          <div className="mt-4">
            <div className="mb-3 bg-white rounded-xl" key={event.id}>
              <Accordion
                key={event?.id}
                expanded={expanded === `panel${event?.id}`}
                onChange={handleChange(`panel${event?.id}`)}
                className="accordion-root p-3"
                style={{
                    boxShadow: "0px 4px 32px 0px #0000001A",
                  }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${event?.id}-content`}
                  id={`panel${event?.id}-header`}
                  className="accordion-summary text-lg font-semibold"
                  style={{ backgroundColor: "white" }}
                >
                  <Typography
                    className="text-lg font-semibold"
                    style={{ fontWeight: "600", fontSize: "18px" }}
                  >
                     {submittedData?.leaderShipTeamDtos?.[index]?.name?.trim()
        ? submittedData.leaderShipTeamDtos[index].name
        : `User ${index + 1}`}
                    {/* User {index +1} */}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="accordion-details bg-white">
                  <Typography component={"div"}>
                    {/* Form details go here */}
                    
       <div className='flex items-center py-3'>
       <img src={
                        files[index] &&
                        files[index] instanceof Blob
                          ? URL.createObjectURL(
                              files[index] as Blob
                            ) // Type assertion here
                          : submittedData?.leaderShipTeamDtos[
                              index
                            ]?.fileDto?.documentUrl || '/images/userImg.svg'
                      }
                        alt="Preview" className='w-[80px] h-[80px] mr-3 rounded-full'  />
       <div>
              <p className="font-semibold text-gray-900 text-base font-sans">
              Upload Hospital Photo
              </p>
              <p className="text-sm font-normal text-gray-500 mt-2 font-sans mb-3">
                Photo should be atleast in 150px X 150px
              </p>
             
              <label className=' mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer'>
            Upload new photo
            <input
              type="file" 
              accept="image/*"
              onChange={(e) =>
                handleFileChanges(e, index)
              }
              className="hidden"
            />
          </label>
            </div>
       </div>
                    <div className="form-group mb-4 ">
                      <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm font-Inter">
                        Name
                      </label>
                      <div className="relative">
                      <input
                    {...register(`leaderShipTeamDtos.${index}.name`, { required: "Name is required" })}
                    type="text"
                    placeholder="Enter Name"
                    
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                      
                  {errors?.leaderShipTeamDtos?.[index]?.name && <p className="text-red-500 text-sm">{errors?.leaderShipTeamDtos?.[index]?.name?.message}</p>}
                      </div>
                    </div>
                     

                    <div className="grid grid-cols-2 gap-20">
                      <div className=" form-group mb-4 ">
                        <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                          Gender
                        </label>
                        <div className="relative">
                        <select
                      {...register(`leaderShipTeamDtos.${index}.gender`)}
                      className="form-control border mt-1 p-2 rounded w-full font-normal font-Inter text-sm text-[#111827]"
                    >
                      <option value="">Select Gender</option>
                    <option value="MALE">Male</option>
                    <option value="FEMALE">Female </option>
                    <option value="OTHERS">Others</option>
                    </select>
                        </div>
                      </div>

                      <div className="form-group mb-4 ">
                        <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                          Designation
                        </label>
                        <div className="relative">
                          <input
                            type="text"
                            placeholder="Enter Designation"
                            {...register(`leaderShipTeamDtos.${index}.designation`)}
                             className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                           
                          />
                        
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-4 ">
                      <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                        Bio
                      </label>
                      <div className="relative">
                        <textarea
                         rows={4}
                          placeholder="Enter Bio"
                          {...register(`leaderShipTeamDtos.${index}.bio`, {
                            maxLength: {
                                value: 1000,
                                message: "Bio must be at most 1000 characters",
                            },})}
                          className="w-full border p-2 rounded-md"
                        />
                        {errors?.leaderShipTeamDtos?.[index]?.bio && (
  <p className="text-red-500 text-sm mt-1">{errors?.leaderShipTeamDtos[index]?.bio?.message}</p>
)}
                      </div>
                    </div>
                    <div className="form-group mb-4 ">
                      <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                      Address
                      </label>
                      <div className="relative">
                        <textarea
                         rows={4}
                          placeholder="Enter Address"
                          {...register(`leaderShipTeamDtos.${index}.address`)}
                          className="w-full border p-2 rounded-md"
                        />
                      </div>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        ))}
        <div
          onClick={handleAddEvent}
          className="mt-8 p-2 w-[11.5rem] h-10 cursor-pointer bg-[#FFFFFF] text-gray-700 rounded border border-gray-300"
        >
          {events.length === 0 ? "+ Add User Details" : "+ Add Another User"}
        </div>
        {/* )} */}
      </div>
    
      {/* </form> */}
    </div>
   <div className='p-8 bg-white mt-8'>
   <p className='font-Inter font-bold text-2xl text-primary-color border-b pb-4 border-b-gray-200'>Add center details</p>
         {/* <form onSubmit={handleSubmit(onFormSubmit)}> */}
         <div className="form-group mb-10 mt-5 w-[80%]">
  
  {events1.map((event: any, index: number) => (
    <div className="mt-4">
      {/* <> */}

      <div className="mb-3 bg-white" key={event.id}>
        <Accordion
          key={event?.id}
          expanded={expanded1 === `panel${event?.id}`}
          onChange={handleChanges(`panel${event?.id}`)}
          className="accordion-root p-3"
          style={{
            boxShadow: "0px 4px 32px 0px #0000001A",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${event?.id}-content`}
            id={`panel${event?.id}-header`}
            className="accordion-summary text-lg font-semibold"
            style={{ backgroundColor: "white" }}
          >
            <Typography
              className="text-lg font-semibold"
              style={{ fontWeight: "600", fontSize: "18px" }}
            >
 {submittedData?.hospitalCenterReqDtos?.[index]?.name?.trim()
        ? submittedData.hospitalCenterReqDtos[index].name
        : `Center ${index + 1}`}
              {/* Center {index +1} */}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordion-details bg-white">
            <Typography component={"div"}>
              {/* Form details go here */}
              <div className="form-group mb-4 ">
                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                Center Name
                  {/* <span className="font-[400]"> (Required)</span> */}
                </label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Enter Center Name "
                    {...register(
                      `hospitalCenterReqDtos.${index}.name`
                    )}
                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  
                  />
                 
                </div>
              </div>

              <div className="grid grid-cols-2 gap-16">
                <div className=" form-group mb-4 ">
                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                Specialization
                 
                </label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Enter Specialization "
                    {...register(
                      `hospitalCenterReqDtos.${index}.specialization`
                    )}
                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                  />
                </div>
                </div>

                <div className="form-group mb-4 ">
                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                Center Size
                </label>
                <div className="relative">
                <div className="relative">
                <select  className="form-control border mt-1 p-2 rounded w-full font-normal font-Inter text-sm text-[#111827]"
                  
                  {...register(
                    `hospitalCenterReqDtos.${index}.centerSize`,
                    // {
                    //   onChange: (e) =>
                    //     handleSelectChange(e, index), // Custom change handler
                    // }
                  )}
                 
                >
                  <option value="">
                    Select Center size
                  </option>
                  <option value="SMALL">Small</option>
                  <option value="MEDIUM">Medium</option>
                  <option value="LARGE">Large</option>
                </select>
              </div>
                 
                </div>
                </div>
              </div>
            
              <div className="form-group mb-4 ">
                <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                Address
                </label>
                <div className="relative">
                <textarea
                 rows={4}
  placeholder="Enter Address"
  {...register(
    `hospitalCenterReqDtos.${index}.branchAddress`
  )}
   className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
/>
                </div>
              </div>
             
             
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>

      {/* </> */}
    </div>
  ))}

  {/* {events.length <= 0 && ( */}
    <div
      onClick={handleAddEvents}
      className="mt-4 p-2 w-[11.5rem] h-10 cursor-pointer bg-[#FFFFFF] text-gray-700 rounded border border-gray-300"
    >
      {events1.length === 0 ? "+ Add Center Details" : "+ Add another Center"}
    </div>
  {/* )} */}
</div>
   </div>
    
      </div>
      
    </div>
    <div className="px-4 flex justify-end  p-4 items-center  bg-white fixed bottom-[15px] w-[78%]"
              style={{
                boxShadow: "0px -16px 50px 0px #0000000D",
              }}>
                 <div></div>
        <div>
         
          <button
            type="submit"
            className="px-7 py-2 gradient-background font-Inter text-white rounded font-bold text-base"
            
          >
            Update 
          </button>
        </div>
      </div>
        </div>
        </form>
        </div>
        
{showConfirmation &&
  <DynamicTextPopup onClose={handleClosePopup} title='  Confirm Profile Update' body='You are about to update  profile information. Please review the changes before saving. This action will overwrite the existing details.' confirmButtonName='Confirm' closeButtonName='Cancel'
  onConfirm={saveData} />
}

    </div>
  )
}

export default EditHospitalProfile
